export const isLocalStorageValueDefined = (value) =>
  value !== 'undefined' && value !== null;

export const hasSomeValueFrom = (arr1, arr2) =>
  arr1.some((element) => arr2.indexOf(element) !== -1);

export const openUrlInNewTab = (url) => {
  window.open(url, '_blank', 'noopener, noreferrer');
};

export const isDefined = (value) => value !== undefined && value !== null;
